<script>
import EBase from './index';

export default {
  components: {
    EBase,
  },
  props: {
    items: EBase.props.items,
  },
  render(create) {
    const options = {
      props: { items: this.items, perPage: 2 },
      attrs: this.$attrs,
      on: this.$listeners,
    };
    return create('EBase', options);
  },
};
</script>
